import type { CoordinatorEvent } from '../_types/events';

export type BeaconInputConfig = {
  mouse: boolean;
  keyboard: boolean;
  touch: boolean;
  gamepad: boolean;
};

export const DEFAULT_BEACON_INPUT_CONFIG: BeaconInputConfig = {
  mouse: true,
  keyboard: true,
  touch: true,
  gamepad: true,
};

export type BeaconState = {
  shareCode: string | null;
  shareLink: string | null;
  streamTitle: string;
  currentPlayers: number;
  maxPlayers: number;
  inputConfig: BeaconInputConfig;
  previewEnabled: boolean;
};

export type BeaconEvents = {
  shareCodeReady: CoordinatorEvent<{ shareCode: string; shareLink: string }>;
  shareCodeEnded: CoordinatorEvent<void>;
  playerCountChanged: CoordinatorEvent<{ currentPlayers: number; maxPlayers: number }>;
  inputConfigChanged: CoordinatorEvent<BeaconInputConfig>;
};
